import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Stack,
  Avatar,
  Button,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import Slider from "react-slick";
import CloseIcon from "@mui/icons-material/Close";
import user1 from "../../assets/images/home/user/user1.png";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { px } from "framer-motion";

function NextArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "50%",
        right: "-48px",
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        height: "16px",
        width: "16px",
        padding: "4px",
        borderRadius: "52%",
        background: "#fdd025",
        transition: "opacity 0.3s ease",
      }}
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <KeyboardDoubleArrowRightIcon />
    </div>
  );
}

function PrevArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "50%",
        left: "-24px",
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        height: "16px",
        width: "16px",
        padding: "4px",
        borderRadius: "52%",
        background: "#fdd025",
        transition: "opacity 0.3s ease",
      }}
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <KeyboardDoubleArrowLeftIcon />
    </div>
  );
}

const Testimonials: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState({
    name: "",
    subtitle: "",
    testimonial: "",
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const handleClickOpen = (testimonial: {
    name: string;
    subtitle: string;
    testimonial: string;
  }) => {
    setSelectedTestimonial(testimonial);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  let studentTestimonials = [
    {
      image: user1,
      name: "Mohini Nilesh Kamat",
      subtitle: "Batch 2014-15",
      testimonial: `
        Being in a medical or paramedical profession is no piece of cake. Lives are affected directly by the skills we possess and those can either gift the patient a new life or completely ruin their health. The role of a physiotherapist is even more complex as this profession focuses on making the patient independent without any drugs or any procedures.
        Naturally to possess skills so that level require no small amount of hard work and guidance from skilled professionals themselves. Modern College of Physiotherapy is an institution that focuses on knowledge beyond rote learning, practical skills and insight into this profession. As a student, I had the opportunity to be guided by individuals of various specializations, with vast knowledge and clinical experience.
        Affiliations with various well-known hospitals ensured that we students got maximum exposure to various cases and hence the various intricacies of treatment. Along with academic activities, this institution also ensured that we enjoyed extracurricular activities, attended state level and national level conferences, opportunities to enhance our talents. This institution recognizes each student's capabilities and encourages them to succeed thereby creating excellent Physiotherapists. Modern College made us worthy of being addressed as Physiotherapists.
      `,
    },
    {
      image: user1,
      name: "Dr.Yogita Nagpal",
      subtitle: "Masters in Musculoskeletal sciences, Batch 2019-2021",
      testimonial: `
        I pursued my masters from Modern College in the year 2019 to 2021 and going back in time I realized that I did not just upgrade my knowledge and skill, I upgraded as a human being.
        This college taught me the importance of interpersonal relationships with colleagues, seniors, juniors, professors, and supporting staff along with knowledge and the curriculum. The first year was a rocky road as the world was hit by COVID-19, but that did not stop us from completing our curriculum as the staff was always supportive.
        The second year turned out to be even tougher as COVID had its after-effects too, but the staff helped us personally when anyone from the batch was affected. During examinations, we received great support from the staff, which allowed us to demonstrate our practical skills well due to the environment provided. The postings at various hospitals certainly helped my clinical skills and helped me develop a good professional demeanor. I will always be grateful to Modern College for helping me become who I am today !!
      `,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: 4,
        mb: 2,
        mt: 1,
        backgroundColor: "secondary.light",
        overflow: "hidden",
      }}
    >
      <Typography
        variant="h4"
        sx={{ fontWeight: "normal", color: "primary.main", mb: 0 }}
      >
        Student Testimonials
      </Typography>
      <Box px={2}>
        <Slider key={isMobile ? "mobile" : "desktop"} {...settings}>
          {studentTestimonials.map((testimonial, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: "secondary.light",
                p: { xs: 1, md: 2 },
                height: "240px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "100%",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {testimonial.name && (
                <Stack
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
                  sx={{
                    border: "1px solid #e0e0e0",
                    p: { xs: 1, md: 2 },
                    mr: { xs: 1, md: 2 },
                    ml: { xs: 0.5 },
                    height: "100%",
                    position: "relative",
                    backgroundColor: "#fff",
                    zIndex: 1,
                    overflow: "hidden",
                    boxSizing: "border-box",
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Avatar
                      src={testimonial.image}
                      alt={testimonial.name}
                      sx={{
                        width: 55,
                        height: 55,
                      }}
                    />
                    <Box
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          fontSize: { xs: "14px", md: "16px" },
                          color: "primary.main",
                          mb: 0,
                        }}
                      >
                        {testimonial.name}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          color: "secondary.main",
                          fontWeight: "bold",
                          fontSize: { xs: "13px", md: "15px" },
                        }}
                      >
                        {testimonial.subtitle}
                      </Typography>
                    </Box>
                  </Stack>

                  <Box sx={{ flexGrow: 1, width: "100%", pr: 1.5, mr: 1.5 }}>
                    <Typography
                      variant="body1"
                      textAlign="justify"
                      sx={{
                        color: "primary.main",
                        lineHeight: 1.6,
                        fontSize: { xs: "12px", md: "14.5px" },
                        mb: 0.5,
                        maxHeight: "7.3em",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {testimonial.testimonial?.split("\n\n")[0]}
                    </Typography>
                    <Button
                      onClick={() => handleClickOpen(testimonial)}
                      sx={{
                        p: 0,
                        mt: 0,
                        ml: 0,
                        color: "primary.main",
                        fontWeight: "bold",
                        fontSize: { xs: "10px", md: "12px" },
                      }}
                    >
                      Show More
                    </Button>
                  </Box>
                </Stack>
              )}
            </Box>
          ))}
        </Slider>
      </Box>
      {/* Dialog for detailed testimonial view */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <Box
          sx={{
            border: "2px solid",
            borderColor: "secondary.main",
            p: 2,
            position: "relative",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "primary.main",
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ mb: 0.5, color: "primary.main" }}
            >
              {selectedTestimonial.name}
              <Typography
                component="span"
                sx={{ color: "secondary.main", fontWeight: "bold" }}
              >
                {" - "}
                {selectedTestimonial.subtitle}
              </Typography>
            </Typography>

            <Typography
              variant="body1"
              color="primary.main"
              textAlign="justify"
              sx={{ fontSize: { xs: "12px", md: "14.5px" } }}
            >
              {selectedTestimonial.testimonial}
            </Typography>
          </DialogContent>
        </Box>
      </Dialog>
    </Box>
  );
};

export default Testimonials;
